// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__HAnMa","dragIcon":"Choice_dragIcon__3rZUp","left":"Choice_left__1PpkW","input":"Choice_input__sVX6_"};